import { MarketplaceSearchPanel } from 'marketplace-embed';
import { jsx as _jsx } from "react/jsx-runtime";
const STANDARD_APP_QUERY = {
  offeringType: 'APP',
  query: {
    type: 'STANDARD',
    fields: {}
  }
};
const getPinnedAppsQuery = pinnedOfferingIds => ({
  offeringType: 'APP',
  query: {
    type: 'CONTEXTUAL',
    fields: {
      contextKey: 'GOSU',
      pinnedOfferingIds
    }
  }
});
const MarketplaceSidePanelContainer = ({
  onClose,
  panelTitle,
  offeringSlug,
  pinnedOfferingIds = []
}) => {
  return /*#__PURE__*/_jsx(MarketplaceSearchPanel, {
    embedQuery: pinnedOfferingIds.length > 0 ? getPinnedAppsQuery(pinnedOfferingIds) : STANDARD_APP_QUERY,
    offeringSlug: offeringSlug,
    onClose: onClose,
    panelTitle: panelTitle,
    preload: true,
    show: true
  });
};
export default MarketplaceSidePanelContainer;